export default __webpack_public_path__ + "static/media/Doribac-250-eng.0aa60d9a.jpg";